import { fetchGetAuth } from "../utils/utils";
import { gamificationActions } from "./gamification-slice";
import { assessmentsActions } from "./assessments-slice";
import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr";



export const initNotificationIntegration = (user) => async (dispatch) => {
    try {
        const connection = new HubConnectionBuilder()
            .withUrl(`${window.config.notificationUrl}/RT/Notification`, {
                transport: HttpTransportType.WebSockets,
                withCredentials: true
            })
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();

        const startConnection = async () => {
            try {
                await connection.start();
            } catch (err) {
                console.error("Error establishing SignalR connection:", err);
                setTimeout(startConnection, 5000); // Retry after 5 seconds
            }
        };

        // Start the SignalR connection
        await startConnection();

        // Handle connection close and reconnect
        connection.onclose(async () => {
            await startConnection();
        });

        // Define event handlers for SignalR
        connection.on("scored", (p) => {
            const resultObject = p.reduce((acc, item) => {
                acc[item.key] = item.value;
                return acc;
            }, {});

            switch (Number(resultObject.ContestId)) {
                case (window.config.contestId):
                    dispatch(gamificationActions.updateProviderScored({ myProviderId: resultObject.ProviderId, myScore: resultObject.Score }));
                    dispatch(assessmentsActions.updateAssessment({ myProviderId: resultObject.ProviderId, score: resultObject.Score, challengeId: resultObject.ChallengeId }));
                    break;
                default:
                    console.log('default in switch in initNotificationIntegration');
            }

            // Dispatch to update the score in the Redux store
            dispatch(gamificationActions.updateScore(resultObject.Score));
        });
    } catch (error) {
        console.error("NotificationIntegration failed to load:", error);
        throw error;
    }
};

export const getGamification = () => {
    return async (dispatch) => {
        try {
            const res = await fetchGetAuth(`${window.config.baseApiUrl}/gamification/api/contest/score`)
            if (res) {
                const myContest = res.find(contest => contest.id === window.config.contestId)
                let myProvidersObject = {}
                myContest.providers.forEach(provider => myProvidersObject[provider.providerId] = provider)
                dispatch(gamificationActions.initProviders(myProvidersObject));
            }
        }
        catch (e) {
            console.log('error in fetch getGamification: ', e);
        }
    }
}